import secondBoxWebp from './secondBox.webp';
import secondBoxJpg1x from './secondBox@1x.jpg';
import secondBoxJpg2x from './secondBox@2x.jpg';

export const secondBoxSources = [secondBoxWebp, secondBoxJpg2x, secondBoxJpg1x];
